import { css } from 'styled-components';
import { legacyShadows } from '../../../theme/shadows.js';
import typography from '../../../theme/typography.js';
export const Primary = {
    colors: {
        main: '#00B2E3',
        mainDark: '#0087C1',
        mainLight: '#CBF6FF',
        positive120: '#056B42',
        positive100: '#1BAB5D',
        positive70: '#1ADB81',
        positive30: '#74E6AD',
        positive10: '#E8FCF1',
        critical120: '#BB2532',
        critical100: '#E8313A',
        critical70: '#F64C56',
        critical30: '#FF8993',
        critical10: '#FFD1DA',
        warning120: '#A57412',
        warning100: '#FBB104',
        warning70: '#FCC736',
        warning30: '#FDDC72',
        warning10: '#FFF2CC',
        link120: '#104D93',
        link100: '#1268ED',
        link70: '#4C8AF6',
        link30: '#B1CFFB',
        link10: '#E7EEFE',
        //
        black_1: '#2E2F33',
        black_2: '#2E2F33',
        black_3: '#2E2F33',
        //
        blackDark_1: '#111113',
        //
        grey00_1: '#FFFFFF',
        grey00_2: '#FFFFFF',
        grey00_5: '#FFFFFF',
        grey00_6: '#FFFFFF',
        grey00_7: '#FFFFFF',
        //
        grey01_1: '#F7F7F8',
        grey01_2: '#F7F7F8',
        grey01_3: '#F7F7F8',
        //
        grey05_1: '#F2F2F3',
        grey05_2: '#F2F2F3',
        grey05_3: '#F2F2F3',
        grey05_4: '#F2F2F3',
        //
        grey10_1: '#EAEBEB',
        grey10_2: '#EAEBEB',
        grey10_5: '#EAEBEB',
        //
        grey30_1: '#D7D8DA',
        grey30_2: '#D7D8DA',
        //
        grey70_1: '#A1A2A8',
        grey70_3: '#A1A2A8',
        //
        grey100_1: '#6D7176',
        grey100_2: '#6D7176',
        // Secondary
        purple120: '#7A05B1',
        purple100: '#A31AE3',
        purple70: '#C876EF',
        purple30: '#DBA3F4',
        purple10: '#FCDDFD',
        //
        purpleBlue120: '#4E2AD9',
        purpleBlue100: '#7551FF',
        purpleBlue70: '#9E84FF',
        purpleBlue30: '#C6B8FF',
        purpleBlue10: '#EBE5FF',
        //
        teal120: '#007474',
        teal100: '#039C9C',
        teal70: '#04CDCD',
        teal30: '#89E8E8',
        teal10: '#D7FEFE',
        //
        pink120: '#CC3683',
        pink100: '#EF5DA8',
        pink70: '#F38BC1',
        pink30: '#F8B9DA',
        pink10: '#FDE8F2',
        //
        lightBlue120: '#0282CA',
        lightBlue100: '#39B8FF',
        lightBlue70: '#6BCAFF',
        lightBlue30: '#9EDCFF',
        lightBlue10: '#E5F6FF',
        //
        coral120: '#E24639',
        coral100: '#FF6F63',
        coral70: '#FF9A92',
        coral30: '#FFD4D0',
        coral10: '#FFF1EF',
        //
        green120: '#36AC4A',
        green100: '#74D585',
        green70: '#8BEF9D',
        green30: '#CEF9D5',
        green10: '#EFFDF1',
        //
        yellow120: '#DAA71A',
        yellow100: '#F4C954',
        yellow70: '#F7D987',
        yellow30: '#FBEFCC',
        yellow10: '#FEFAEE',
        // Marketing colors
        indigo700: '#3D0A5C',
        indigo600: '#4C0C73',
        indigo500: '#5C0F8B',
        indigo450: '#934BBF',
        indigo400: '#C987F2',
        indigo300: '#E0AEFF',
        indigo200: '#F2DCFF',
        //
        sky700: '#004171',
        sky600: '#0087C1',
        sky500: '#00B2E3',
        sky400: '#7EE3FF',
        sky300: '#A5EFFF',
        sky200: '#CBF6FF',
        sky100: '#ECFCFF',
        //
        sapphire700: '#00236E',
        sapphire600: '#002A84',
        sapphire500: '#0033A1',
        sapphire400: '#1257EA',
        sapphire300: '#6495FF',
        sapphire200: '#CCDCFF',
        sapphire100: '#ECF2FF',
        //
        ocean700: '#003A69',
        ocean600: '#005398',
        ocean500: '#0071CE',
        ocean400: '#49ADFF',
        ocean300: '#A6D7FF',
        ocean200: '#D7EDFF',
        ocean100: '#ECF7FF',
        //
        lime700: '#717A00',
        lime600: '#A1AE00',
        lime500: '#CDDE00',
        lime400: '#E6F349',
        lime300: '#F5FE8B',
        lime200: '#FBFFD1',
        //
        lemon700: '#BCAE00',
        lemon600: '#DFD123',
        lemon500: '#F6E948',
        lemon400: '#FFF576',
        lemon300: '#FFFBC7',
        lemon200: '#FFFDE1',
        //
        steel700: '#6D7E89',
        steel600: '#9DB0BC',
        steel500: '#BECCD5',
        steel400: '#D0DCE3',
        steel300: '#E1ECF2',
        steel200: '#F2FAFF',
        steel100: '#F8FCFF',
        //
        midnight700: '#000C17',
        midnight600: '#071420',
        midnight500: '#131E29',
        midnight400: '#314151',
        midnight300: '#50667C',
        midnight200: '#8DA3BA',
        midnight100: '#DDE3EA',
        //
        slate700: '#273139',
        slate600: '#3F4B55',
        slate500: '#5B6670',
        slate400: '#909AA4',
        slate300: '#ADB9C4',
        slate200: '#D3DFEB',
        slate100: '#F3F7FA',
    },
    shadows: {
        ...legacyShadows,
        focus: css `
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.mainLight};
    `,
        error: css `
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.critical10};
    `,
        warning: css `
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.warning10};
    `,
        success: css `
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.positive10};
    `,
        large: css `
      box-shadow:
        0 10px 30px rgb(40 50 64 / 12%),
        0 0 3px rgb(0 0 0 / 10%);
    `,
        medium: css `
      box-shadow:
        0 0 3px rgb(0 0 0 / 8%),
        0 8px 24px rgb(0 0 0 / 4%);
    `,
        small: css `
      box-shadow:
        0 4px 10px rgb(0 0 0 / 2%),
        0 1px 2px rgb(0 0 0 / 2%);
    `,
    },
    typography,
    borders: {
        radiusMedium: 8,
    },
    themeId: 'primary',
};
